import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { solarServicePages } from "@/data/solarServiceContent";

export const Route = createFileRoute("/services/solar-inverter-installation")({
  head: () => ({
    meta: [
      { title: "Solar Inverter Installation in Southern California – McKay Roofing & Solar" },
      { name: "description", content: "String and micro-inverter installs and replacements across Southern California. Restore full solar system output with the right inverter." },
      { property: "og:title", content: "Solar Inverter Installation – McKay Roofing & Solar" },
      { property: "og:description", content: "Install or replace solar inverters to restore full output in Southern California." },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/solar-inverter-installation" }],
  }),
  component: () => <RoofingServicePage {...solarServicePages["solar-inverter-installation"]} />,
});